<template>
  <b-row class="life-lost disease-pages no-gutters">
  <b-col class="tool-border" cols="12">
    <b-col class="reduce-padding" cols="12">
      <wlpHeader :pageTitle="pageTitle" :pageImage="pageImage" ></wlpHeader>
    </b-col>
    
    <b-col class="page-background-gradient reduce-padding" cols="12">
      <b-row class="page-content  no-gutters">
        <b-row class="body-sec no-gutters">
          <b-col class="reduce-padding top-section" cols="12">
            <div class="top-text-title bold-text">
              {{$t('common.top-text-title')}}
            </div>
            <div class="top-text">
           {{$t('lifelost.top-text')}}
            </div>
            <div class="top-hr"></div>
          </b-col>
          
          <b-col class="reduce-padding graph-col" lg="8" md="7" cols="12">
            <b-row class="no-gutters graph-heading alignment-space">
                <div class="graph-heading-text bold-text">
                  {{$t('lifelost.graphTitle')}}
                </div>
                <div class="graph-heading-text">
                  ({{$t('lifelost.subHeading')}})<sup>a</sup>
                </div>
            </b-row>    
            <div class="graphs-div">
              <div class="bar-graph-div">
                <barGraph :disease="'yll'" :barValues="userData.calc.yearsLost" :adjustSelection="userData.adjustButtons.yearsLost" :displayBars="true" :lblY=lblY :lblEndX="9" :lblStartX="0" :lblSkipX="1"
                :confInt="this.userData.confInt.yearsLost"></barGraph>
              </div>
             </div>
            
            <b-col class="graph-bottom left-spacing" cols="12">
              <b-row class="no-gutters">
                <b-col class="top-space reduce-padding legends" lg="7" cols="12">
                  <div class="life-section" :class="{'life-section-sp' : $i18n.locale=='sp'}">
                      <div class ="weight-loss-txt before-loss">
                        <div class="bullet blue"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" >{{$t('common.beforeWeight')}}</div>
                      </div>
                      <div class ="weight-loss-txt" :class="{'after-loss-sp' : $i18n.locale=='sp' , 'after-loss' : $i18n.locale=='en'}">
                        <div class="bullet green" v-if="userData.adjustButtons.yearsLost>0"></div>
                        <div class="bullet-text" :class="{'bullet-text-sp' : $i18n.locale=='sp'}" v-if="userData.adjustButtons.yearsLost>0">{{$t('common.afterWeight')}}</div>
                      </div>  
                  </div>
                </b-col>
                <b-col class="odds-ratio sub-text-width safari_only"   :class="{'odds-ratio-sp' : $i18n.locale=='sp'}" lg="5" cols="12">
                  <b-row class=" no-gutters">
                    <sup class = "years-life-sup">a</sup>{{$t('lifelost.footer')}}
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-col>
          <b-col class="reduce-padding adj-weight-col" md="4" cols="12">
            <b-row class="no-gutters">
              <b-col class="triangle-outer reduce-padding" cols="12">
                <div class = "triangle-img"></div>
              </b-col>
              <b-col class=" years-lost reduce-padding">
                <weightAdjustmentBox :disease="'years of life lost'" :adjustSelection="userData.adjustButtons.yearsLost" @adjustPercUpdate="userData.adjustButtons.yearsLost=$event"></weightAdjustmentBox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-row>
      <wlpNavigation :navButtons="['info','references','tnc','menu','back','next']" :currentScreen="9"></wlpNavigation>
    </b-col>
  </b-col>
  </b-row>
</template>
<script>
  import scrollMixin from "../mixins/scrollMixin";
  import wlpNavigation from '../components/wlpNavigation.vue';
  import wlpHeader from '../components/wlpHeader.vue';
import barGraph from '../components/barGraph.vue';
import weightAdjustmentBox from '../components/weightAdjustmentBox.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: "lifeLost",
  mixins: [scrollMixin],
  mounted: function () {
    this.scrollToTop();
    this.markSectionComplete({section:'yearsLost'});
  },
  computed: {
      ...mapGetters('userData', ['userData']),
    },
  components: {
    'wlpNavigation': wlpNavigation,
    'wlpHeader': wlpHeader,
    'weightAdjustmentBox': weightAdjustmentBox,
    'barGraph': barGraph,
  },

  data() {
    return {
        pageTitle: this.$t('lifelost.pageTitle'),
        pageImage: 'lostlife-img',
        lblY: [this.$t('common.bmi'),this.$t('common.bmi')],
        // years: this.$t('lifelost.years'),
    };
  },
  
  methods: {
    ...mapMutations('userData', ['markSectionComplete']),
  }
};
</script>


<style lang="scss" scoped>
</style>
